<template>
  <div class="r-left">
    <div class="r-left-logo">
      <el-image :src="require('../../assets/image/resource/platform.png')" fit="fill"></el-image>
      <div>平台资源</div>
    </div>
    <div class="r-hen">

    </div>
    <div class="r-nav">
      <el-menu :default-openeds="[routerPath]" @close="close" @open="opens" class="el-menu-vertical-demo">
        <!-- <el-submenu index="/resource/all">
                      <template slot="title">
                          <el-image :src="require('../../assets/image/resource/leftnva.png')" fit="fill" :lazy="true"></el-image>
                          <span>全部</span>
                      </template>
                  </el-submenu> -->
        <el-submenu :index="item.url" :key="index" v-for="(item, index) in navList">
          <template slot="title">
            <el-image :lazy="true" :src="require('../../assets/image/resource/leftnva.png')" fit="fill"></el-image>
            <span>{{ item.title }}</span>
          </template>
          <el-menu-item-group>
            <!-- <template slot="title">作者</template> -->
            <div :class="(idArr.indexOf(items.id) == -1) ? '' : 'is-active'" :key="index" @click="jumpQuery(item.url, items, item.idArr)"
                 class="menu-item" v-for="(items, index) in item.child">
              <div class="item-icon"></div>
              <span>{{ items.title }}</span>
            </div>
            <!-- <el-menu-item :index="items.id+''" @click="jumpQuery(item.url,items,item.idArr)" v-for="(items, index) in item.child"  :key="index" >
                              {{items.title}}
                          </el-menu-item> -->
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
  import {listCategory, listStatistics} from '../../api/resource'

  export default {
    name: 'PortalLeftnav',

    data() {
      return {
        navList: [
          {
            title: '古籍底本',
            url: '/resource/inbook',

            child: [],
            idArr: []
          }, {
            title: '精品图书',
            url: '/resource/author',
            child: [],
            idArr: []
          }, {
            title: '民俗视频',
            url: '/resource/video',
            child: [],
            idArr: []
          }, {
            title: '民俗图片',
            url: '/resource/image',
            child: [],
            idArr: []
          }, {
            title: '民俗音频',
            url: '/resource/audio',
            child: [],
            idArr: []
          }
        ],
        idArr: [],
        params: [],
      };
    },

    mounted() {
      this.init()
      this.$Bus.$on('left', (data) => {
        this.$Bus.$emit('sublibrary', {})
      })
    },
    methods: {
      async init() {
        const tem = await this.categInit()
        const istics = await this.Statistics()
        let obj = {}
        let newList = istics.map((item) => {
          const id = item.value.split('-')[0]
          const value = item.value.split('-')[1]
          item.coolId = id
          item.title = value
          return item
        }).reduce((item, next) => {
          obj[next.coolId] ? '' : obj[next.coolId] = true && item.push(next)
          return item
        }, []).map(m => {
          m.positionList = JSON.parse(JSON.stringify(istics.filter(f => f.coolId == m.coolId)))
          m.title = tem.find(f => f.id == m.coolId).name
          return m
        })
        this.navList.map((e) => {
          const tems = newList.find((i) => i.title == e.title)
          const ss = tem.find((m) => m.name == e.title)
          if (tems) {
            e.child = tems.positionList
          }
          if (ss) {
            e.id = ss.id
          }
        })
        if (this.$route.path == '/resource/all') return
        // 初始化category
        const id = this.navList.find(e => e.url == this.$route.path).id
        sessionStorage.removeItem('classification')
        sessionStorage.setItem('category', JSON.stringify({
          searchName: 'category',
          searchRelation: "1",
          searchType: "1",
          searchValue: id
        }))


        // this.setSessingCategory(id)
      },
      Statistics() {
        return new Promise((reject, provide) => {
          listStatistics({
            englishNames: 'groupClassification',
            typeId: this.$store.state.typeId
          }).then(res => {
            if (res.data.code == 200) {
              reject(res.data.data)
            }
          })
        })
      },
      categInit() {
        return new Promise((reject, provide) => {
          listCategory({
            typeId: this.$store.state.typeId,
          }).then(res => {
            if (res.data.code == 200) {
              reject(res.data.data)
            }
          })
        })
      },
      jumpQuery(url, items) {
        // if(this.navList.find(data=>data.url == url).idArr.indexOf(items.id)==-1){
        //     this.navList.find(data=>data.url == url).idArr.push(items.id)
        // }else{
        //     this.navList.find(data=>data.url == url).idArr.splice(this.navList.find(data=>data.url == url).idArr.indexOf(items.id),1)
        // }
        if (this.idArr.indexOf(items.id) == -1) {
          this.idArr.push(items.id)
          this.params.push({
            searchName: 'classification',
            searchRelation: "0",
            searchType: "1",
            searchValue: items.title
          })
          sessionStorage.setItem('classification', JSON.stringify(this.params))
        } else {
          this.idArr.splice((this.idArr.indexOf(items.id)), 1)
          this.params.splice(this.params.findIndex(e => e.searchValue == items.title), 1)
        }
        let pas = JSON.parse(JSON.stringify(this.params))
        if (this.params.length == 1) {
          pas.map(e => {
            e.searchRelation = 1
            return e
          })
        }
        sessionStorage.setItem('classification', JSON.stringify(pas))
        this.$Bus.$emit('classification', JSON.stringify(pas))
      },
      // 设置 Category
      setSessingCategory(id) {
        // 每次 跳转前清除classification
        sessionStorage.removeItem('classification')
        sessionStorage.setItem('category', JSON.stringify({
          searchName: 'category',
          searchRelation: "1",
          searchType: "1",
          searchValue: id
        }))
        this.$Bus.$emit('category', JSON.stringify({
          searchName: 'category',
          searchRelation: "1",
          searchType: "1",
          searchValue: id
        }))
      },
      opens(i) {
        this.idArr = []
        const id = this.navList.find(e => e.url == i).id
        sessionStorage.removeItem('classification')
        // sessionStorage.setItem('category', JSON.stringify({
        //   searchName: 'category',
        //   searchRelation: "1",
        //   searchType: "1",
        //   searchValue: id
        // }))
        this.$router.push({
          path: i,
        })
        setTimeout(() => {
          this.setSessingCategory(id)
        }, 200);
      },
      close(i) {
        sessionStorage.removeItem('category')
        sessionStorage.removeItem('classification')
        this.$router.push({
          path: '/resource/all',
        })
        setTimeout(() => {
          this.$Bus.$emit('category', {})
        }, 200)
      }
    },
    computed: {
      routerPath() {
        return this.$route.path;
      },
    },
  };
</script>
<style lang="less" scoped>
  .r-left {
    .r-left-logo {
      font-size: 1.25rem;
      color: #333333;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 0.365rem;
      border-bottom: 0.052rem solid #b73d43;;
    }

    .r-hen {
      width: 100%;
      height: 0.313rem;
      background-color: #b73d43;
      margin-top: 0.052rem;
    }

    .r-nav {
      /deep/ .el-menu {
        border-right: none;

        .el-submenu {
          margin-bottom: 0.208rem;

          .el-submenu__title {
            background-color: #f8f1f1;
            border-radius: 0.208rem;
            font-size: 0.938rem;
            font-weight: bold;
            color: #333333;

            .el-image {
              width: 1.198rem;
              height: 0.885rem;
              margin-right: 0.521rem;
            }
          }

          .el-menu-item-group {
            .menu-item {
              display: flex;
              align-items: center;
              cursor: pointer;
              color: #808080;
              height: 50px;
              line-height: 50px;
              padding: 0 45px;
              min-width: 200px;
              padding-left: 40px;
              background-color: rgb(255, 255, 255);


              .item-icon {
                min-width: 0.833rem;
                min-height: 0.833rem;
                background-color: #ffffff;
                border-radius: 0.104rem;
                border: solid 0.052rem #808080;
                position: relative;
                margin-right: 0.4rem;
              }

              .item-icon::before {
                content: "+";
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                // width: 0.833rem;
                // height: 0.833rem;
              }

              span {
                overflow: hidden;
                text-overflow: ellipsis; //多出部分用...代替
                display: -webkit-box; //定义为盒子模型显示
                -webkit-line-clamp: 1; //用来限制在一个块元素显示的文本的行数
                -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
              }
            }

            .menu-item.is-active,
            .menu-item:hover {
              color: #b73d43;
              text-shadow: 0px 0 0 currentColor;

              .item-icon {
                border: solid 0.052rem #b73d43;
                color: #fff;
                background-color: #b73d43;
              }

            }

            .menu-item.is-active {
              .item-icon::before {
                content: "-";
              }
            }
          }
        }
      }
    }

  }</style>
